import { navigate, Link } from "gatsby";
import React, { useContext, useState, useEffect } from "react";
import { FirebaseContext } from "../Firebase";
import LoadingWall from "../LoadingWall";
import Mobile from "./mobile";

function Navbar({ darkMode }) {
  const { firebase, user, loading } = useContext(FirebaseContext);
  const [naviLoading, setNaviLoading] = useState(false);
  function handleLogoutClick() {
    firebase.logout().then(() => (window.location.href = "/login"));
  }

  return (
    <div
      data-animation="over-right"
      data-collapse="medium"
      data-duration="400"
      data-easing="ease"
      data-easing2="ease"
      role="banner"
      className={darkMode ? "navbar dark w-nav" : "navbar w-nav"}
    >
      {naviLoading && <LoadingWall />}
      {!user ? (
        <div className="container w-container">
          <a href="/" aria-current="page" className="brand w-nav-brand w--current">
            <div className={darkMode ? "text-block-3 light" : "text-block-3"}>
              OSCEhub 🩺{" "}
              {/* <span class={darkMode ? "text-span-5 light" : "text-span-5"}>
                BETA
              </span> */}
            </div>
          </a>
          <nav role="navigation" className="nav-menu w-nav-menu">
            <a
              className={
                darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
              }
              onClick={() => {
                setNaviLoading(true);
                navigate("/browse");
                setNaviLoading(false);
              }}
            >
              Browse
            </a>
            <a
              className={
                darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
              }
              onClick={() => {
                setNaviLoading(true);
                navigate("/example");
                setNaviLoading(false);
              }}
            >
              Examples
            </a>
            <a
              href="https://oscehub.noorahq.com/feature-requests"
              target="_blank"
              className={
                darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
              }
            >
              Feedback
            </a>
            <a
              onClick={() => {
                setNaviLoading(true);
                navigate("/#prices");
                setNaviLoading(false);
              }}
              className={
                darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
              }
            >
              Pricing
            </a>
            <a
              onClick={() => {
                setNaviLoading(true);
                navigate("/login");
                setNaviLoading(false);
              }}
              className={
                darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
              }
            >
              Log in
            </a>
            <div
              className={
                darkMode
                  ? "nav-link focused-button w-nav-link light"
                  : "nav-link focused-button w-nav-link"
              }
              onClick={() => {
                setNaviLoading(true);
                navigate("/registration");
                setNaviLoading(false);
              }}
            >
              Free Trial
            </div>
          </nav>
          <Mobile darkMode={darkMode} />
        </div>
      ) : (
        <div className="container w-container">
          <a
            onClick={() => navigate("/")}
            aria-current="page"
            className="brand w-nav-brand w--current"
          >
            <div className={darkMode ? "text-block-3 light" : "text-block-3"}>
              OSCEhub 🩺{" "}
              {/* <span class={darkMode ? "text-span-5 light" : "text-span-5"}>
                BETA
              </span> */}
            </div>
          </a>
          <nav role="navigation" className="nav-menu w-nav-menu">
            {user && (
              <div
                className={
                  darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
                }
              >
                {`ID: ${user.shortId}`}
              </div>
            )}
            <a
              onClick={() => navigate("/dashboard")}
              target="_blank"
              className={
                darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
              }
            >
              Dashboard
            </a>
            <a
              href="https://oscehub.noorahq.com/feature-requests"
              target="_blank"
              className={
                darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
              }
            >
              Feedback
            </a>
            <a
              className={
                darkMode ? "nav-link light w-nav-link" : "nav-link w-nav-link"
              }
              onClick={handleLogoutClick}
            >
              Log out
            </a>
            <a
              href="/#prices"
              className={
                darkMode ? "nav-link focused-button light w-nav-link"
                  : "nav-link focused-button w-nav-link purple-box"
              }
            >
              Subscribe
            </a>
            
          </nav>
          <Mobile darkMode={darkMode} />
        </div>
      )}
    </div>
  );
}

export default Navbar;
